import React, {useEffect, useState} from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { MinicartDiscounts } from "../MinicartDiscounts/MinicartDiscounts";

export const CartTotals = ({ cart_subtotal, cart_items, settings }) => {

    // Calculate total savings for items with a selling plan
    const totalSavings = cart_items.reduce((acc, item) => {

    if (item.selling_plan_allocation) {
      const originalPrice = item.selling_plan_allocation.compare_at_price; // Original price before discount
      const discountedPrice = item.selling_plan_allocation.price; // Discounted price (current price)
      const itemSavings =
        ((originalPrice - discountedPrice) / 100) * item.quantity;
      return acc + itemSavings;
    } else if (item.line_level_discount_allocations) {
      let itemDiscount = 0;
      item.line_level_discount_allocations.forEach(discount => {
        itemDiscount += discount.amount;
      });
      const itemSavings = ((itemDiscount) / 100);
      return acc + itemSavings;
    } else {
        const originalPrice = item.product?.compare_at_price; // Original price before discount\
        if (originalPrice) {
            const discountedPrice = item.price; // Discounted price (current price)
            const itemSavings =
                ((originalPrice - discountedPrice) / 100) * item.quantity;
            return acc + itemSavings;
        }
    }
    return acc;
    }, 0);

    const totalBeforeSavings = totalSavings + cart_subtotal;

    const showTotal = true;
    const showSubtotal = false;
    const showShipping = false;
    const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();

    return (
    <div className={"pt-[18px]"}>
      {showSubtotal &&<div className="minicart__totals">
        <Paragraph text={"SUBTOTAL"} type={"h4"} />
        {totalSavings > 0 ? (
          <Paragraph text={`${currencySymbol}${totalBeforeSavings.toFixed(2)}`} type={"h4"} />
        ) : (
          <Paragraph text={`${currencySymbol}${totalBeforeSavings.toFixed(0)}`} type={"h4"} />
        )}
      </div>}
      {totalSavings > 0 && (
        <div className="minicart__totals">
          <Paragraph
            text={"TOTAL SAVINGS"}
            type={"h4"}
          />
          <div
            className={
              "savings-pill h4 flex"
            }
          >
            -{currencySymbol}{totalSavings.toFixed(2)}
          </div>
        </div>
      )}
        {showShipping && <div className="minicart__totals">
        <Paragraph text={"SHIPPING"} type={"h4"} />
        <div className={"flex flex-col"}>
          <Paragraph
            text={`Calculated at checkout`}
            type={"b2"}
          />
          <Paragraph
            text={`Free for orders over $99`}
            type={"b2"}
          />
        </div>
      </div>}
        {showTotal && <div className="minicart__totals">
        <Paragraph text={"TOTAL"} type={"h4"} />
        {totalSavings > 0 ? (
          <Paragraph text={`${currencySymbol}${cart_subtotal.toFixed(2)}`} type={"h4"} />
        ) : (
          <Paragraph text={`${currencySymbol}${cart_subtotal.toFixed(0)}`} type={"h4"} />
        )}
      </div>}

        <MinicartDiscounts cart_subtotal={cart_subtotal} settings={settings} />
    </div>
  );
};
